module.exports = __webpack_public_path__ + "static/media/facebook.e2f6ef66.svg";